import React from 'react'
import PizzaLoading from "../../strapi/loading-gifs/Pizza-loading";
import { Button } from '../Layout/Elements';
import EmptyBox from "../../assets/components-icons/empty-box.svg";
import { useHistory } from "react-router-dom";
import { ReactComponent as Scooter } from "../../assets/components-icons/scooter.svg";
import { ReactComponent as Bag } from "../../assets/components-icons/bag.svg";
import CartItems from './CartItems';
import {CartItemsWrapper} from '../Layout/CartItemsWrapper';


 const CartList = ({ cart, loading, get_delivery, delivery, total  }) => {
     let history = useHistory();

  if (loading) {
      return <PizzaLoading />
  }
  if (cart.length === 0) {
      return (
      <div className="empty-basket">
        <img src={EmptyBox} alt="title" />
        <h4 className="mt-3">Cart is Empty</h4>
        <Button
          onClick={() => history.push("/")}
          bg="var(--navbar-bg)"
          width="100%"
          maxWidth="300px"
          padding="10px"
          fontWeight="bold"
          fontSize="13px"
          className="mt-3"
        >
          Fill it
        </Button>
      </div>
    );
  }
  else {
return (
    <CartItemsWrapper>
        <div className='container mt-5 py-5'>
            <div className='row'>
<div className="col-lg-6 col-6">
                <div className="d-flex">
                  <h6>Product</h6>
                </div>
              </div>

              <div className="col-lg-6 col-6">
                <div className="d-flex mobile-control justify-content-around">
                  <div>
                    <h6>Price</h6>
                  </div>

                  <div>
                    <h6>Quantity</h6>
                  </div>
                </div>
              </div>
              <div className="borderAll borderGrey  mt-1"></div>
                { cart.map((item) => {
                    return <CartItems key={item.id} history={history} {...item} />
                } ) }
            </div>
            <div className="col-lg-6 mt-4">
                    <div className="d-lg-flex  mobile-small-control justify-content-around">
                      <div className="mt-3 p-2">
                        <label className="container-radio">
                          <input
                            onClick={get_delivery}
                            name="deliveryOption"
                            value="With Delivery"
                            className="mr-2"
                            type="radio"
                          />
                          <span className="checkmark"></span>
                          <Scooter className="svgAll svg-delivery ml-3" />
                          <span className="ml-1">With delivery</span>
                        </label>
                      </div>

                      <div className="mt-3 p-2">
                        <label className="container-radio">
                          <input
                            onClick={get_delivery}
                            name="deliveryOption"
                            value="Pickup"
                            className="mr-2"
                            type="radio"
                          />
                          <span className="checkmark"></span>
                          <Bag className="svgAll svg-delivery ml-3" />
                          <span className="ml-1">Pick up</span>
                        </label>
                      </div>
                    </div>

                    <div className="d-lg-flex   mobile-small-control flex-column mr-5 mt-3 align-items-start">
                      <div>
                        <span> {delivery} </span>
                      </div>

                      <div>
                        <span>
                          Total: <small className="total"> €{total} </small>
                        </span>
                      </div>
                    </div>

                    <div className="d-flex   mt-4">
                      <Button
                        bg="var(--navbar-bg)"
                        fontWeight="bold"
                        fontSize="13.5px"
                        padding="10px"
                        width="100%"
                        maxWidth="300px"
                        onClick={() => {
                          history.push("/checkout");
                        }}
                      >
                        Procced to checkout
                      </Button>
                    </div>
                  </div>
        </div>
        </CartItemsWrapper>
    )
  }
}


export { CartList as default };